/** @module Sourcing/AggregateSRTSuppliers */
define([
    "dojo/_base/declare",
    "csi/table/AggregateFrom"
], function(declare,AggregateFrom) {

    return declare(AggregateFrom, {

        saveResourceId: "Change",

        /**
         * @override
         *
         * Change the selection in the action popup to radio button (single choice) when data package template is supplier specific
         */
        getFormData: function() {
            var formData = this.inherited(arguments);
            formData.m_bSelectOne = true;
            formData.m_bOmitSelections = false;
            return formData;
        }

    });
});